/* eslint-disable import/no-duplicates */
/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

import { setupLayouts } from 'virtual:generated-layouts'
// Composables
import { createRouter, createWebHistory } from 'vue-router/auto'
import { routes } from 'vue-router/auto-routes'
import { useAdminStore } from '@/stores/admin'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: setupLayouts(routes),
})

// Add route guard to protect admin routes
router.beforeEach(async to => {
  if (to.path === '/admin/reports/notification_integrity') {
    return '/admin/reports/notification-integrity'
  }

  const adminStore = useAdminStore()

  const isAdminRoute = to.path.startsWith('/admin')
  if (!isAdminRoute) {
    return true
  }

  const isLoggedIn = await adminStore.ensureSession()

  // Treat /admin as an entrypoint and send users to the right destination.
  if (to.path === '/admin') {
    return isLoggedIn ? '/admin/dashboard' : '/admin/login'
  }

  // If trying to access admin routes (except login), check if authenticated
  if (to.path === '/admin/login') {
    // If already logged in and trying to access login page, redirect to dashboard
    if (isLoggedIn) {
      return '/admin/dashboard'
    }
    return true
  }

  // For other admin routes, require authentication
  if (isLoggedIn) {
    return true
  } else {
    return '/admin/login'
  }
})

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  if (err?.message?.includes?.('Failed to fetch dynamically imported module')) {
    if (localStorage.getItem('vuetify:dynamic-reload')) {
      console.error('Dynamic import error, reloading page did not fix it', err)
    } else {
      console.log('Reloading page to fix dynamic import error')
      localStorage.setItem('vuetify:dynamic-reload', 'true')
      location.assign(to.fullPath)
    }
  } else {
    console.error(err)
  }
})

router.isReady().then(() => {
  localStorage.removeItem('vuetify:dynamic-reload')
})

export default router
